import { createColumnHelper } from '@tanstack/react-table';

import { RoleRowData } from '../types';

export const columnHelper = createColumnHelper<RoleRowData>();
